import { render, staticRenderFns } from "./financialRatios.vue?vue&type=template&id=76b53138&scoped=true"
import script from "./financialRatios.vue?vue&type=script&lang=js"
export * from "./financialRatios.vue?vue&type=script&lang=js"
import style0 from "./financialRatios.vue?vue&type=style&index=0&id=76b53138&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b53138",
  null
  
)

export default component.exports